// Session + tracking helpers. All tracking is fire-and-forget, silent fail.
import { api } from './api';

const SESSION_KEY = 'spec_session_id';
const CONSENT_KEY = 'cookie_consent';

export const getSessionId = () => {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return 'anon';
  }
};

export const consentAccepted = () => {
  try {
    return localStorage.getItem(CONSENT_KEY) !== 'rejected';
  } catch {
    return true;
  }
};

const fire = async (path, payload) => {
  if (!consentAccepted()) return;
  try {
    await api.post(path, { ...payload, session_id: getSessionId() });
  } catch {
    /* silent */
  }
};

export const trackPageview = (path, referrer) => fire('/track/pageview', { path, referrer: referrer || document.referrer || '' });
export const trackSearch = (query, results = 0) => fire('/track/search', { query, results });
export const trackCategory = (category, treatment) => fire('/track/category', { category, treatment });
export const trackFormStart = (category) => fire('/track/formstart', { category });
export const trackClinic = (clinic_name, category) => fire('/track/clinic', { clinic_name, category });
